import { FocusSchema, IdSchema, LocaleSchema } from "@uzverse/core";
import { z } from "zod";
/**
 * Event type the node appends (for the company owner, `onBehalfOf`) when a company, task, agent or
 * connection budget stops a run. Payload: `{ scope, spentUsd, limitUsd, agentId }`.
 */
export const BUDGET_ALERT_EVENT = "node.budgetAlert";
/**
 * Company-node routes beyond the core `NODE_API`, called by control-plane services with a signed
 * service token (`node` scope; `admin` scope for `/v1/admin/*`). The caller names the human the
 * call is for (`userId`); the node runs it with that human's grants (and the Owner's for admin).
 */
export const NODE_EXTRA_API = {
    /** GET `?limit&before`: tasks of one requester, newest first. */
    userTasks: "/v1/users/:userId/tasks",
    /** POST `ToolInvokeRequest` → core `ToolInvocationResult`: a human's UI action as a tool call. */
    toolInvoke: "/v1/tools/invoke",
    /** GET: settings descriptors the user may see (user scope, company scope read-only or editable). */
    userSettings: "/v1/users/:userId/settings",
    /** PUT `{ value }` / DELETE (reset). */
    userSetting: "/v1/users/:userId/settings/:key",
    /** GET → `ModelCatalogResponse`: the selectable models and effort levels. */
    models: "/v1/models",
    /** GET → `{ seq }`: the entity change feed head (where a new gateway subscriber starts). */
    entityHead: "/v1/entities/head",
    /** GET → `{ id, name }`: the node's company record (`name` null until `org.createCompany`). */
    company: "/v1/company",
    /** MCP Streamable HTTP endpoint for agent runs (MCP principal tokens, not service tokens). */
    mcp: "/mcp",
    admin: {
        agents: "/v1/admin/agents",
        /** GET `?limit` */
        jobs: "/v1/admin/jobs",
        /** GET core `CostQuery` fields as query parameters. */
        costs: "/v1/admin/costs",
        /** GET: pending hire escalations. */
        hires: "/v1/admin/hires",
        /** POST `{ decision, decidedBy, note? }` → hiring decision. */
        hireDecision: "/v1/admin/hires/:requestId/decision",
        /** GET → `{ policy }`; PUT `{ policy, by }` (`CompanyModelPolicy`, stored as `engine.model.*` settings). */
        modelPolicy: "/v1/admin/model-policy",
        /**
         * Prefix of the agent-engine connection routes (`/companies/:companyId/connections...`).
         * The acting Owner is passed in the `x-uz-user` header.
         */
        connections: "/v1/admin",
    },
};
/** Header naming the acting human on admin calls (the node trusts it only with an admin token). */
export const ACTING_USER_HEADER = "x-uz-user";
export const ToolInvokeRequestSchema = z.object({
    name: z.string().min(1),
    input: z.unknown(),
    userId: IdSchema,
    locale: LocaleSchema,
    focus: FocusSchema.nullable().optional(),
    approvalId: IdSchema.optional(),
});
export const HireDecisionBodySchema = z.object({
    decision: z.enum(["approved", "rejected"]),
    decidedBy: IdSchema,
    note: z.string().max(2000).optional(),
});
export const PendingHireSchema = z.object({
    requestId: IdSchema,
    floorId: IdSchema,
    reason: z.string(),
    roleName: z.string(),
    justification: z.string(),
    taskId: IdSchema.nullable(),
    approverUserId: IdSchema.nullable(),
});
//# sourceMappingURL=node.js.map